import React, { useCallback } from 'react';
import { ConfirmationModal, Icon, Interactable, useConfirmationModal } from 'LocalGluons';
import { ImageBackground } from 'react-native';
import MirroringPreventDialog from 'LocalGluons/components/PlayerContainer/components/MirroringPreventDialog';
import useMirroringCheck from 'LocalGluons/components/PlayerContainer/hooks/useMirroringCheck';
import { useStore } from 'Store';
import { t } from 'Locale';
import NavigationService from 'NavigationService';
import { Device } from 'DeviceUtils';
import defaultStyles from '../../Details.jss';

interface PlayButtonProps {
    onPressPlay: () => void;
    previewHeight: number;
    previewImage: string;
    isUserAbleToPlay: boolean;
    item: any;
}

const PlayButton = ({
    isUserAbleToPlay,
    onPressPlay,
    previewHeight,
    previewImage,
    item,
}: PlayButtonProps): JSX.Element => {
    const { getIsMirroring } = useMirroringCheck();
    const { setModalContent } = useConfirmationModal();
    const { userData, setPlayerData } = useStore();
    const navigation = NavigationService.getAppNavigationInstance();

    const closeDialog = useCallback(() => {
        setModalContent(null);
        setPlayerData(null);

    }, [setModalContent, setPlayerData]);

    return (
        <Interactable testID="play_button" onPress={async () => {
            if (Device.isWeb) {
                document.querySelector('#videoPlayer')?.play?.();
            }
            const isMirroring = await getIsMirroring();
            if (isMirroring) {
                setModalContent(<MirroringPreventDialog setModalContent={setModalContent} />);
            } else if (userData === null) {
                setModalContent(
                    <ConfirmationModal
                        icon="warning_yellow_black"
                        header={t('NOT_LOGGED_IN_MSG')}
                        message={t('NOT_LOGGED_IN_TXT')}
                        confirmLabel={t('COMMON.LOGIN')}
                        cancelLabel={t('COMMON.CANCEL')}
                        onConfirm={() => {
                            navigation.navigate('Login');
                            closeDialog();
                        }}
                        onCancel={closeDialog}
                        onClose={closeDialog}
                    />
                );
            }
            else {
                onPressPlay();
            }
        }} disabled={!isUserAbleToPlay}>
            <ImageBackground
                resizeMode="cover"
                style={[
                    defaultStyles.previewImage
                    // height done here to avoid issues with android
                ]}
                source={{ uri: previewImage }}
            >
                {isUserAbleToPlay && <Icon style={defaultStyles.playButton} name="play_arrow" />}
            </ImageBackground>
        </Interactable>
    )
        // }
        // return (
        //     <View testID="play_button">
        //         <ImageBackground
        //             resizeMode="cover"
        //             style={[
        //                 defaultStyles.previewImage
        //                 // height done here to avoid issues with android
        //             ]}
        //             source={{ uri: previewImage }}
        //         />
        //     </View>
        // );
        ;
};
export default PlayButton;
